import { createSlice } from "@reduxjs/toolkit";

// Initial state
export const bulkUploadInitialState = {
  bulkUploadItemCondition: null,
  bulkUploadConditionText: null,
  bulkUploadDiscountProfile: {},
};

// Slice
const bulkUploadSlice = createSlice({
  name: "bulkUpload",
  initialState: bulkUploadInitialState,
  reducers: {
    // Set bulk upload item condition
    setBulkUploadItemCondition: (state, action) => {
      state.bulkUploadItemCondition = action.payload;
    },

    // Set bulk upload condition text
    setBulkUploadConditionText: (state, action) => {
      state.bulkUploadConditionText = action.payload;
    },

    setBulkUploadDiscountProfile: (state, action) => {
      state.bulkUploadDiscountProfile = {
        ...state.bulkUploadDiscountProfile,
        ...action.payload,
      };
    },

    // Reset all state
    resetBulkUpload: () => bulkUploadInitialState,
  },
});

// Export actions
export const {
  setBulkUploadItemCondition,
  setBulkUploadConditionText,
  setBulkUploadDiscountProfile,
  resetBulkUpload,
} = bulkUploadSlice.actions;

// Export selectors
export const selectBulkUploadItemCondition = (state) =>
  state.bulkUpload?.bulkUploadItemCondition;

export const selectBulkUploadConditionText = (state) =>
  state.bulkUpload?.bulkUploadConditionText;

export const selectBulkUploadDiscountProfile = (state) =>
  state.bulkUpload?.bulkUploadDiscountProfile;

// Export reducer
export default bulkUploadSlice.reducer;
